import { type ReactNode } from "react";
import DPadKeyWrapper from "../../components/layouts/arrowKeyNavigation/ArrowKeyNavigator";
import Sidebar from "../../components/layouts/sidebar/Sidebar";
import useWindowSize from "../../modules/helpers/windowSize";
import HeroSectionContextProvider from "../../modules/shared/heroSection/heroSectionContext/HeroSectionContextProvider";
import * as styles from "./styles.module.scss";

interface IProps {
  children: ReactNode;
}

const MainLayout = (props: IProps) => {
  const [width, height] = useWindowSize();

  return (
    <HeroSectionContextProvider>
      <div className={styles.container} style={{ height, width }}>
        <Sidebar />
        <DPadKeyWrapper />
        <main className={styles.defaultLayerContentWrapper}>{props.children}</main>
      </div>
    </HeroSectionContextProvider>
  );
};

export default MainLayout;
